import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'
import global from '../../utils/global'
import storage from '@/utils/storagehandle'

const vue = new Vue()

const state = {
  /*
  * 任务管理
  * */
  pointList: [],
  getStatus6TaskDetailsList: [],
  finishForPickingList: [],
  getGoodsList: [],
  getGoodsBatchList: [],
  supplementGoodsBatchList: '',
  editTaskList: [],
  assignmentList: {},
  importTask: {},
  mergeList: [],
  detailedList: [],
  locationList: [],
  reservoirList: [],
  assignmentMark: 0,
  plateNum: 0,
  taskMerge: '',
  taskCodeList: '',
  assignmentAddList: {}, // 添加商品列表
  assignmentAddMark: 0,
  assignmentEdit: {}, // 编辑时，获取信息
  taskEdit: {}, // 编辑时，任务信息
  assignmentEditAdd: [], // 编辑时，新增列表
  assignmentEditAdding: [], // 编辑 - 进行中，新增列表
  assigneditMark: 0, // 编辑标识
  type: '', // 接单类型
  goodsListEdit: [], // 编辑时，列表信息
  locationList: [], // 出库任务 - 详情（拣货货位列表）
  downloadList: '',
  assignmentInfo: {}, // 查看任务详情
  supplierSelect: [], // 供应商下拉框数据
  childeList: [], // 任务类型下拉框数据
  supplierSelects: {}, // 任务列表下拉框数据
  // 筛选条件
  // picker: '', // 选择时间
  // supplierCode: '', // 供应商编号
  // status: '', // 状态
  // nature: '', // 性质
  // beginTime: '', // 筛选开始时间
  // endTime: '', // 筛选结束时间
  // typeCode: '', // 任务类型编码
  taskPrintBillIntoGoodList: storage.getItem('taskPrintBillIntoGoodList') || [], // 打印入库单时的商品列表
  taskPrintBillIntoGoodsTotalPiece: storage.getItem('taskPrintBillIntoGoodsTotalPiece') || '', // 打印入库单时的共计件数
  taskPrintBillIntoGoodsSku: storage.getItem('taskPrintBillIntoGoodsSku') || '', // 打印入库单时的SKU种数
  taskPrintBillOutGoodList: storage.getItem('taskPrintBillOutGoodList') || [], // 打印出库单时的商品列表
  taskPrintBillOutGoodsTotalPiece: storage.getItem('taskPrintBillOutGoodsTotalPiece') || '', // 打印出库单时的共计件数
  taskPrintBillOutGoodsSku: storage.getItem('taskPrintBillOutGoodsSku') || '', // 打印出库单时的SKU种数
  taskPrintBillPickGoodList: storage.getItem('taskPrintBillPickGoodList') || [], // 打印拣货单时的商品列表
  taskPrintBillPickGoodsTotalPiece: storage.getItem('taskPrintBillPickGoodsTotalPiece') || '', // 打印拣货单时的共计件数
  taskPrintBillPickGoodsSku: storage.getItem('taskPrintBillPickGoodsSku') || '', // 打印拣货单时的SKU种数
  taskPrintBillPutawayGoodList: storage.getItem('taskPrintBillPutawayGoodList') || [], // 打印上架单时的商品列表
  taskPrintBillPutawayGoodsTotalPiece: storage.getItem('taskPrintBillPutawayGoodsTotalPiece') || '', // 打印上架单时的共计件数
  taskPrintBillPutawayGoodsSku: storage.getItem('taskPrintBillPutawayGoodsSku') || '', // 打印上架单时的SKU种数
  taskPrintBillEditCode: null, // 打印时的任务code
  isCancelTaskBtnDis: false,
  isTakeOrdersBtnDis: false,
  isSaveBtnDis: false,
  isConfirmBtnDis: false,
  goodsBatchSelect: [], // 出库（生产日期下拉框）
  /*
  * 贴标任务
  * */
  labelAssignmentList: {},
  labelAssignmentMark: 0,
  // searchFormInfo: {
  //   ref: null,
  //   data: {
  //     supplier: '',
  //     goodsName: '',
  //     ddId: '',
  //     settlementStatus: '',
  //     isPrint: '',
  //     beginTime: ''
  //   },
  //   rules: {},
  //   labelWidth: '90px'
  // },
  /*
  * 包膜任务
  * */
  filmTaskList: {},
  filmTaskMark: 0,
  filmTaskInfo: {},
  constMark: 0,
  // filmSearchFormInfo: {
  //   ref: null,
  //   data: {
  //     supplier: '',
  //     settlementStatus: '',
  //     beginTime: null
  //   },
  //   rules: {},
  //   labelWidth: '90px'
  // }
  // printTemplateData: [] // 打印面板数据
  /*
  * 出入库明细
  * */
  warehouseDetailList: [],
  warehouseDetailTotal: 0,
  signForList: [],
  taskLogList: [],
  updateStatusMark: 0,
  updateStatusError: {},
  tenantDrop: {},
  activateDraftList: '',
  byTenant: []
}

const actions = {

  // 计算板数
  [types.COUNTPLATENUM] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/task/countPlateNum', params, 'application/json').then(data => {
        context.commit(types.COUNTPLATENUM, data)
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },
  //  , params
  // 仓点下拉

  [types.GETALLPOINT] (context, params) {
    http.fetch('/api/ycDispatchPlatformPoint/all', params).then(data => {
      context.commit(types.GETALLPOINT, data)
    })
  },
  [types.getGoods] (context, params) {
    http.fetch('/api/task/getGoods', params).then(data => {
      context.commit(types.getGoods, data)
    })
  },
  [types.getGoodsBatch] (context, params) {
    http.fetch('/api/task/getGoodsBatch', params, 'application/json').then(data => {
      context.commit(types.getGoodsBatch, data)
    })
  },
  [types.supplementGoodsBatch] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/task/supplementGoodsBatch', params, 'application/json').then(data => {
        context.commit(types.supplementGoodsBatch, data)
        if (data.code === 200) {
          resolve(data)
        }
      }).catch((err) => {
        reject(err)
      })
    })
    // http.fetch('/api/task/supplementGoodsBatch', params).then(data => {
    //   context.commit(types.supplementGoodsBatch, data)
    // })
  },
  [types.activateDraft] (context, params) {
    http.fetch('/api/task/activateDraft', params).then(data => {
      context.commit(types.getGoodsBatch, data)
    })
  },
  [types.editTask] (context, params) {
    http.fetch('/api/task/editTask', params, 'application/json').then(data => {
      context.commit(types.editTask, data)
    })
  },
  [types.getStatus6TaskDetails] (context, params) {
    http.fetch('/api/task/getStatus6TaskDetails', params).then(data => {
      context.commit(types.getStatus6TaskDetails, data)
    })
  },
  [types.finishForPicking] (context, params) {
    http.fetch('/api/task/finishForPicking', params).then(data => {
      context.commit(types.finishForPicking, data)
    })
  },
  // 出库任务批量导入
  [types.IMPORTASK] (context, params) {
    http.fetch('/api/task/importTask', params).then(data => {
      context.commit(types.IMPORTASK, data)
    })
  },
  // 获取-合并单列表
  [types.GETOUTBOUNDTASKMERGELIST] (context, params) {
    http.fetch('/outbound/task/merge/getOutboundTaskMergeList', params, 'application/json').then(data => {
      context.commit(types.GETOUTBOUNDTASKMERGELIST, data)
    })
  },
  // 获取-库区下拉列表
  [types.GETWAREHOUSEARERSSELECT] (context, params) {
    http.fetch('/outbound/task/merge/getWarehouseAresSelect', params).then(data => {
      context.commit(types.GETWAREHOUSEARERSSELECT, data)
    })
  },
  // 获取-库位下拉列表
  [types.GETWAREHOUSEADDESSSELECT] (context, params) {
    http.fetch('/outbound/task/merge/getWarehouseAddressSelect', params).then(data => {
      context.commit(types.GETWAREHOUSEADDESSSELECT, data)
    })
  },
  // 获取-库位下拉列表
  [types.download] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/task/download', params, 'application/json', false, {responseType: 'arraybuffer'}).then(data => {
        resolve(data)
      })
    })
  },
  // [types.download] (context, params) {
  //   http.fetch('/api/task/download', params).then(data => {
  //     context.commit(types.download, data)
  //   })
  // },
  // 获取-合并单详情
  [types.GETOUTBOUNDTASKMERGEINFO] (context, params) {
    http.fetch('/outbound/task/merge/getOutboundTaskMergeInfo', params).then(data => {
      context.commit(types.GETOUTBOUNDTASKMERGEINFO, data)
    })
  },
  [types.ADDOUTBOUNDTASKMERGE] (context, params) {
    http.fetch('/outbound/task/merge/addOutboundTaskMerge', params, 'application/json').then(data => {
      context.commit(types.ADDOUTBOUNDTASKMERGE, data)
    })
  },
  [types.FINISHWAREHOUSETASKMERGE] (context, params) {
    http.fetch('/outbound/task/merge/finishWarehouseTaskMerge', params, 'application/json').then(data => {
      context.commit(types.FINISHWAREHOUSETASKMERGE, data)
    })
  },
  /*
  * 任务管理
  * */
  // 获取列表
  [types.TASKGETPAGE] (context, params) {
    http.fetch('/api/task/getPage', params).then(data => {
      context.commit(types.TASKGETPAGE, data)
    })
  },
  // 新增
  [types.TASKADD] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/task/add', params, 'application/json').then(data => {
        context.commit(types.TASKADD, data)
        if (data.code === 200) {
          resolve(data)
        }
      }).catch((err) => {
        reject(err)
      })
    })
  },
  [types.saveBatchProduction] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/task/saveBatchProduction', params, 'application/json').then(data => {
        context.commit(types.saveBatchProduction, data)
        if (data.code === 200) {
          resolve(data)
        }
      }).catch((err) => {
        reject(err)
      })
    })
  },
  // 新增 - 获取任务列表
  [types.TASKGETGOODS] (context, params) {
    http.fetch('/api/task/getGoods', params).then(data => {
      context.commit(types.TASKGETGOODS, data)
    })
  },
  // 新增 - 出库（获取生产日期下拉框）
  [types.GETGOODSBATCH] (context, params) {
    http.fetch('/api/task/getGoodsBatch', params).then(data => {
      context.commit(types.GETGOODSBATCH, data)
    })
  },
  // 编辑
  [types.TASKUPDATE] (context, params) {
    http.fetch('/api/task/update', params).then(data => {
      context.commit(types.TASKUPDATE, data)
    })
  },
  // 编辑 - 获取新增列表
  [types.TASKGETGOODSS] (context, params) {
    http.fetch('/api/task/getGoods', params).then(data => {
      context.commit(types.TASKGETGOODSS, data)
    })
  },
  // 编辑 - 获取新增列表 - 进行中
  [types.TASKGETGOODTSS] (context, params) {
    http.fetch('/api/task/getGoods', params).then(data => {
      context.commit(types.TASKGETGOODTSS, data)
    })
  },
  // 查看任务详情
  [types.GETTASKDETAILS] (context, params) {
    http.fetch('/api/task/getTaskDetails', params).then(data => {
      context.commit(types.GETTASKDETAILS, data)
    })
  },
  // 取消任务 / 接单
  [types.UPDATESTATUSS] (context, params) {
    // http.fetch('/api/task/updateStatus', params).then(data => {
    //   context.commit(types.UPDATESTATUSS, data)
    // })
    // return new Promise((resolve, reject) => {
    //   http.fetch('/api/task/updateStatus', params).then(data => {
    //     if (data.code === 200) {
    //       let message = params.status === 4 ? '您已取消该任务' : '您已接单成功'
    //       vue.$message({
    //         showClose: true,
    //         message,
    //         type: 'success'
    //       })
    //       resolve(data)
    //     }
    //     reject(data)
    //   })
    // })
    return new Promise((resolve, reject) => {
      http.fetch('/api/task/updateStatus', params, null, true).then(data => {
        context.commit(types.UPDATESTATUSS, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 任务管理 - 供应商下拉框数据
  [types.SUPPLIERGETLISTDATA] (context, params) {
    http.fetch('/api/supplier/getAllSupplier', params).then(data => {
      context.commit(types.SUPPLIERGETLISTDATA, data)
    })
  },
  // 确认完成
  [types.COMPLETETASK] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/task/completeTask', params, 'application/json').then(data => {
        // context.commit(types.SETSAVEBTNDIS, false)
        // context.commit(types.SETCONFIRMBTNDIS, false)
        // context.commit(types.COMPLETETASK, data)
        resolve(data)
      })
    })
    // context.commit(types.SETSAVEBTNDIS, true)
    // context.commit(types.SETCONFIRMBTNDIS, true)
  },
  // 任务管理 - 供应商下拉框数据
  [types.SUPPLIERGETLIST] (context, params) {
    let {type} = params
    http.fetch('/api/supplier/getAllSupplier', params).then(data => {
      context.commit(types.SUPPLIERGETLIST, {...data, type})
    })
  },
  // 任务管理 - 任务类型下拉框
  [types.GETCHIDES] (context, params) {
    http.fetch('/api/dict/getChild', params).then(data => {
      context.commit(types.GETCHIDES, data)
    })
  },
  // 任务管理 - 出库任务（已完成补传单据）
  [types.UPDATETASKURLS] (context, params) {
    http.fetch('/api/task/updateTaskUrls', params).then(data => {
      context.commit(types.UPDATETASKURLS, data)
    })
  },
  [types.SAVETASKPRINTBILLINTODATA] (context, data) {
    return new Promise((resolve, reject) => {
      context.commit(types.SAVETASKPRINTBILLINTODATA, data)
      resolve()
    })
  },
  [types.SAVETASKPRINTBILLOUTDATA] (context, data) {
    return new Promise((resolve, reject) => {
      context.commit(types.SAVETASKPRINTBILLOUTDATA, data)
      resolve()
    })
  },
  [types.SAVETASKPRINTBILLPICKDATA] (context, data) {
    return new Promise((resolve, reject) => {
      context.commit(types.SAVETASKPRINTBILLPICKDATA, data)
      resolve()
    })
  },
  [types.SAVETASKPRINTBILLPUTAWAYDATA] (context, data) {
    return new Promise((resolve, reject) => {
      context.commit(types.SAVETASKPRINTBILLPUTAWAYDATA, data)
      resolve()
    })
  },
  /*
  * 贴标任务
  * */
  // 获取列表
  [types.TASKGETPSUPPLIERTASKLABLE] (context, params) {
    http.fetch('/api/supplierTaskLable/getPage', params).then(data => {
      context.commit(types.TASKGETPSUPPLIERTASKLABLE, data)
    })
  },
  // 新增
  [types.SUPPLIERTASKLABLEADD] (context, params) {
    http.fetch('/api/supplierTaskLable/add', params).then(data => {
      context.commit(types.SUPPLIERTASKLABLEADD, data)
    })
  },
  // 作废
  [types.SUPPLIERTASKLABLECANCEL] (context, params) {
    http.fetch('/api/supplierTaskLable/cancel', params).then(data => {
      context.commit(types.SUPPLIERTASKLABLECANCEL, data)
    })
  },
  /*
  * 包膜任务
  * */
  // 获取列表
  [types.GETENVELOPEPAGE] (context, params) {
    http.fetch('/api/supplierTaskLable/getEnvelopePage', params).then(data => {
      context.commit(types.GETENVELOPEPAGE, data)
    })
  },
  // 新增
  [types.ADDENVELOPE] (context, params) {
    http.fetch('/api/supplierTaskLable/addEnvelope', params, 'application/json').then(data => {
      context.commit(types.ADDENVELOPE, data)
    })
  },
  // 查看
  [types.GETENVELOPE] (context, params) {
    http.fetch('/api/supplierTaskLable/getEnvelope', params).then(data => {
      context.commit(types.GETENVELOPE, data)
    })
  },
  // 获取打印面板数据
  [types.GETTEMPLATEDATA] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/printTemplate/print', params).then(data => {
        resolve(data.obj)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 关闭打印面单模板
  [types.CANCELPRINTTEMP] (context) {
    context.commit(types.CANCELPRINTTEMP)
  },
  // 进行中，点击打印面单，保存页面数据
  [types.CHANGEGOODSLISTNUM] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/printTemplate/changeGoodsListNum', params, 'application/json').then(data => {
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /*
  * 出入库明细
  * */
  // 获取列表
  [types.GETALLTASKGOOD] (context, params) {
    http.fetch('/api/task/getAllTaskGood', params).then(data => {
      context.commit(types.GETALLTASKGOOD, data)
    })
  },
  // 查看生产日期
  [types.QUERYGOODSPRODUCTIONTIME] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/task/queryGoodsProductionTime', params).then(data => {
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取签收数量登记/签收信息列表
  [types.GETTASKSIGNREGISTERLIST] (context, params) {
    http.fetch('/api/task/getTaskSignRegisterList', params).then(data => {
      context.commit(types.GETTASKSIGNREGISTERLIST, data)
    })
  },
  // 获取操作记录
  [types.GETTASKLOGLIST] (context, params) {
    http.fetch('/api/task/getTaskLogList', params).then(data => {
      context.commit(types.GETTASKLOGLIST, data)
    })
  },
  // 提交签收数量登记
  [types.SUBMITTASKSIGNREGISTER] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/task/submitTaskSignRegister', params, 'application/json').then(data => {
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  [types.GETTENANTDROP] (context, params) {
    http.fetch('/api/tenant/getTenantDrop', params).then(data => {
      context.commit(types.GETTENANTDROP, data)
    })
  },
  [types.GETBYTENANT] (context, params) {
    http.fetch('/api/warehouse/getWarehouseDropByTenant ', params).then(data => {
      context.commit(types.GETBYTENANT, data)
    })
  },
  BATCH_TASK_SET_DATE (context, params) {
    context.commit(types.getStatus6TaskDetails, params)
  }
}

const mutations = {
  // 计算板数

  [types.COUNTPLATENUM] (state, data) {
    state.plateNum = data.obj
  },
  // 仓点下拉
  [types.GETALLPOINT] (state, data) {
    state.pointList = data.obj
  },
  [types.getStatus6TaskDetails] (state, data) {
    state.getStatus6TaskDetailsList = data.obj
  },
  [types.finishForPicking] (state, data) {
    state.finishForPickingList = data.obj
  },
  [types.getGoods] (state, data) {
    state.getGoodsList = data.obj
  },
  [types.getGoodsBatch] (state, data) {
    state.getGoodsBatchList = data.obj
  },
  [types.supplementGoodsBatch] (state, data) {
    state.supplementGoodsBatchList = data.obj
  },

  [types.activateDraft] (state, data) {
    state.activateDraftList = data.obj
  },
  [types.editTask] (state, data) {
    state.editTaskList = data.obj
  },
  // 出库任务批量导入
  [types.IMPORTASK] (state, data) {
    state.importTask = data.obj
    console.log(data, '出库任务批量导入')
    vue.$message({
      showClose: true,
      message: data.message
    })
  },
  // 获取-合并单列表GETWAREHOUSEARERSSELECT
  [types.GETOUTBOUNDTASKMERGELIST] (state, data) {
    state.mergeList = data.rows
    // console.log(data, '出库任务批量导入')
    // vue.$message({
    //   showClose: true,
    //   message: data.message
    // })
  },
  // 获取-库位下拉列表
  [types.GETWAREHOUSEADDESSSELECT] (state, data) {
    state.reservoirList = data.obj
  },
  // 获取-库区下拉列表
  [types.GETWAREHOUSEARERSSELECT] (state, data) {
    state.locationList = data.obj
  },
  // 下载出库商品批量导入模板
  [types.download] (state, data) {
    // state.downloadList = data.obj
    // 2. 创建 Blob 对象（兼容不同响应类型）
    // const blob = new Blob([data],{type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

    // // 3. 创建临时下载链接
    // const downloadUrl = window.URL.createObjectURL(blob);

    // // 4. 创建隐藏的 a 标签并模拟点击
    // const link = document.createElement('a');
    // link.href = downloadUrl;
    // link.download = '模板.xlsx'; // 设置文件名
    // link.style.display = 'none';
    // document.body.appendChild(link);
    // link.click();
  },
  // 获取-合并单详情
  [types.GETOUTBOUNDTASKMERGEINFO] (state, data) {
    state.detailedList = data.obj
  },
  [types.ADDOUTBOUNDTASKMERGE] (state, data) {
    state.taskCodeList = data.message
    console.log(data, '出库任务批量导入')
    vue.$message({
      showClose: true,
      message: data.message
    })
  },
  [types.FINISHWAREHOUSETASKMERGE] (state, data) {
    state.taskMerge = data.message
    console.log(data, '出库任务批量导入')
    vue.$message({
      showClose: true,
      message: data.message
    })
  },

  /*
  * 任务管理
  * */
  // 获取列表
  [types.TASKGETPAGE] (state, data) {
    state.assignmentList = data
    // console.log(state.assignmentList, '任务管理列表')
  },
  // 新增
  [types.TASKADD] (state, data) {
    if (data.code === 200) {
      state.assignmentAddMark = 1
      vue.$message({
        showClose: true,
        message: '新增成功',
        type: 'success'
      })
    }
  },
  // 新增
  [types.saveBatchProduction] (state, data) {
    if (data.code === 200) {
      // state.assignmentAddMark = 1
      vue.$message({
        showClose: true,
        message: '新增成功',
        type: 'success'
      })
    }
  },
  // 新增 - 获取任务列表
  [types.TASKGETGOODS] (state, data) {
    data.obj.forEach((item, index) => {
      item.select = false
      item.index = index
      item.num1 = 0
      item.wornNum = 0
    })
    data.rows = data.obj
    state.assignmentAddList = data
  },
  // 新增 - 出库（获取生产日期下拉框）
  [types.GETGOODSBATCH] (state, data) {
    state.goodsBatchSelect = data.obj
  },
  // 编辑 - 获取新增列表
  [types.TASKGETGOODSS] (state, data) {
    data.obj.forEach(item => {
      if (item.goodsCode) {
        item.val = item.goodsCode
        item.id = item.goodsCode
      }
    })
    state.assignmentEditAdd = data.obj
    // console.log(state.assignmentEditAdd, '获取新增列表')
  },
  // 编辑 - 获取新增列表 - 进行中
  [types.TASKGETGOODTSS] (state, data) {
    data.obj.forEach(item => {
      item.actualWornNum = 0
    })
    state.assignmentEditAdding = data.obj
    // console.log(state.assignmentEditAdd, '获取新增列表')
  },
  // 编辑
  [types.TASKUPDATE] (state, data) {
    console.log(data)
    state.assignmentMark = 1
    vue.$message({
      showClose: true,
      message: '编辑成功',
      type: 'success'
    })
  },
  // 查看任务详情
  [types.GETTASKDETAILS] (state, data) {
    let urlList = []
    let urlList1 = []
    if (data.obj.task.urls != null && data.obj.task.urls !== '') {
      urlList = data.obj.task.urls.split(',')
      for (let i = 0; i < urlList.length; i++) {
        urlList1.push(`${global.httpBaseURL}/image/${urlList[i]}`)
      }
    }
    data.obj.task.urls = urlList1
    state.taskEdit = data.obj.task
    if (data.obj.task.status === 2) {
      data.obj.goodsList.forEach(item => {
        item.actualNum = item.num
        item.actualWornNum = item.wornNum
      })
    }
    state.goodsListEdit = data.obj.goodsList
    state.locationList = data.obj.locationList
  },
  // 取消任务 / 接单 / 批量配送完成
  [types.UPDATESTATUSS] (state, data) {
    //   console.log(data.code === 200, 'data')
    //   if (data.code === 200) {
    //     state.updateStatusMark = 1
    //     vue.$message({
    //       showClose: true,
    //       message: '操作成功',
    //       type: 'success'
    //     })
    //   } else {
    //     state.updateStatusMark = 2
    //     state.updateStatusError = data.obj
    //   }
  },
  // 设置是否禁用接单按钮
  [types.SETTAKEORDERSBTNDIS] (state, data) {
    state.isTakeOrdersBtnDis = data
  },
  // 设置是否禁用取消任务按钮
  [types.SETCANCELTASKBTNDIS] (state, data) {
    state.isCancelTaskBtnDis = data
  },
  // 设置是否禁用确认完成模板配置保存按钮
  [types.SETSAVEBTNDIS] (state, data) {
    state.isSaveBtnDis = data
  },
  // 设置是否禁用确认完成按钮
  [types.SETCONFIRMBTNDIS] (state, data) {
    state.isConfirmBtnDis = data
  },
  // 任务管理 - 供应商下拉框数据
  [types.SUPPLIERGETLISTDATA] (state, data) {
    // data.obj.push({
    //   code: '',
    //   name: '全部'
    // })
    data.obj.forEach(item => {
      item.name = item.supplierName
      item.code = item.supplierCode
    })
    state.supplierSelects = data.obj
    console.log(data, '任务管理 - 供应商下拉框数据')
  },
  // // 确认完成
  // [types.COMPLETETASK] (state, data) {
  //   console.log(data)
  //   if (data.code === 200) {
  //     vue.$confirm('保存完成。', '提示', {
  //       confirmButtonText: '确定',
  //       showCancelButton: false,
  //       type: 'success'
  //     }).then(() => {
  //       state.assigneditMark = 1
  //     }).catch(() => {
  //     })
  //   }
  // },
  // 任务管理 - 供应商下拉框数据
  [types.SUPPLIERGETLIST] (state, data) {
    data.obj.forEach(item => {
      item.name = item.supplierName
      item.code = item.supplierCode
      item.id = item.supplierCode
    })
    state.supplierSelect = data.obj
    if (data.type) return false
    // state.supplierSelect.push({
    //   name: '全部',
    //   code: ''
    // })
  },
  // 任务管理 - 任务类型下拉框
  [types.GETCHIDES] (state, data) {
    state.childeList = []
    data.obj.forEach((item, index) => {
      if (item.name === '包膜' || item.name === '贴标') {
        data.obj.splice(index, 1)
      }
    })
    state.childeList = data.obj

    // console.log(data, '任务类型下拉框')
  },
  // 任务管理 - 出库任务（已完成补传单据）
  [types.UPDATETASKURLS] (state, data) {
    if (data.code !== 200) return false
    state.assigneditMark = 1
    vue.$message({
      showClose: true,
      message: '上传成功',
      type: 'success'
    })
  },
  [types.SAVETASKPRINTBILLOUTDATA] (state, data) {
    state.taskPrintBillOutGoodList = data.goodsListEdit
    state.taskPrintBillOutGoodsTotalPiece = data.goodsTotalPiece
    state.taskPrintBillOutGoodsSku = data.goodsSku
    storage.setItem('taskPrintBillOutGoodList', data.goodsListEdit)
    storage.setItem('taskPrintBillOutGoodsTotalPiece', data.goodsTotalPiece)
    storage.setItem('taskPrintBillOutGoodsSku', data.goodsSku)
  },
  [types.SAVETASKPRINTBILLPICKDATA] (state, data) {
    state.taskPrintBillPickGoodList = data.goodsListEdit
    state.taskPrintBillPickGoodsTotalPiece = data.goodsTotalPiece
    state.taskPrintBillPickGoodsSku = data.goodsSku
    storage.setItem('taskPrintBillPickGoodList', data.goodsListEdit)
    storage.setItem('taskPrintBillPickGoodsTotalPiece', data.goodsTotalPiece)
    storage.setItem('taskPrintBillPickGoodsSku', data.goodsSku)
  },
  [types.SAVETASKPRINTBILLPUTAWAYDATA] (state, data) {
    state.taskPrintBillPutawayGoodList = data.goodsListEdit
    state.taskPrintBillPutawayGoodsTotalPiece = data.goodsTotalPiece
    state.taskPrintBillPutawayGoodsSku = data.goodsSku
    storage.setItem('taskPrintBillPutawayGoodList', data.goodsListEdit)
    storage.setItem('taskPrintBillPutawayGoodsTotalPiece', data.goodsTotalPiece)
    storage.setItem('taskPrintBillPutawayGoodsSku', data.goodsSku)
  },
  [types.SAVETASKPRINTBILLINTODATA] (state, data) {
    state.taskPrintBillIntoGoodList = data.goodsListEdit
    state.taskPrintBillIntoGoodsTotalPiece = data.goodsTotalPiece
    state.taskPrintBillIntoGoodsSku = data.goodsSku
    storage.setItem('taskPrintBillIntoGoodList', data.goodsListEdit)
    storage.setItem('taskPrintBillIntoGoodsTotalPiece', data.goodsTotalPiece)
    storage.setItem('taskPrintBillIntoGoodsSku', data.goodsSku)
  },
  /*
  * 贴标任务
  * */
  // 获取列表
  [types.TASKGETPSUPPLIERTASKLABLE] (state, data) {
    state.labelAssignmentList = data
  },
  // 新增
  [types.SUPPLIERTASKLABLEADD] (state, data) {
    if (data.code !== 200) return false
    state.labelAssignmentMark = 1
    state.assignmentMark = 1
    vue.$message({
      showClose: true,
      message: '新增成功',
      type: 'success'
    })
  },
  // 作废
  [types.SUPPLIERTASKLABLECANCEL] (state, data) {
    if (data.code !== 200) return false
    state.labelAssignmentMark = 1
    state.filmTaskMark = 1
    vue.$message({
      showClose: true,
      message: '作废成功',
      type: 'success'
    })
  },
  /*
  * 包膜任务
  * */
  // 获取列表
  [types.GETENVELOPEPAGE] (state, data) {
    state.filmTaskList = data
  },
  // 新增
  [types.ADDENVELOPE] (state, data) {
    if (data.code !== 200) return false
    state.filmTaskMark = 1
    vue.$message({
      showClose: true,
      message: '新增成功',
      type: 'success'
    })
  },
  // 查看
  [types.GETENVELOPE] (state, data) {
    state.filmTaskInfo = data
  },
  [types.CANCELPRINTTEMP] (state) {
    state.constMark = 1
  },
  /*
  * c出入库明细
  * */
  // 获取列表
  [types.GETALLTASKGOOD] (state, data) {
    console.log(data)
    if (data.rows && data.rows.length) {
      state.warehouseDetailList = data.rows
    } else {
      state.warehouseDetailList = []
    }
    state.warehouseDetailTotal = data.total
  },
  // 查看生产日期
  [types.QUERYGOODSPRODUCTIONTIME] (state, data) {

  },
  // 签收信息
  [types.GETTASKSIGNREGISTERLIST] (state, data) {
    state.signForList = data.obj
  },
  // 操作记录
  [types.GETTASKLOGLIST] (state, data) {
    state.taskLogList = data.obj
  },
  [types.GETTENANTDROP] (state, data) {
    state.tenantDrop = data.obj
  },
  [types.GETBYTENANT] (state, data) {
    state.byTenant = data.obj
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/assignmentManage/index.js